import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Picture, TwoOne } from "../Layout/Layout";
import { Description } from "../Typography";
import { Button } from "../guide/Stream/styled";
import { desktop } from "../../theme";

const Card = styled("div")(
  css({
    background: "#fff",
    borderRadius: 20,
    padding: 20,
  })
);

const Source = styled("p")({
  color: "#808080",
});

const Stats = styled("div")(
  css({
    display: "flex",
    color: "#808080",
    fontSize: 1,

    span: {
      whiteSpace: "nowrap",
      mr: 60,
    },
  })
);

export const Blog = ({
  url,
  title,
  source,
  image,
  subscribers,
  auditory,
  children,
}) => (
  <TwoOne
    css={css({
      [desktop]: {
        marginTop: 100,
      },
    })}
  >
    <Card>
      <Description>
        <h4>{title}</h4>
        <Source>{source}</Source>
        {(subscribers || auditory) && (
          <Stats>
            {subscribers && (
              <span>
                Подписчики: <strong>{subscribers}</strong>
              </span>
            )}
            {auditory && (
              <span>
                Аудитория: <strong>{auditory}</strong>
              </span>
            )}
          </Stats>
        )}
        <p>{children}</p>
        {url && (
          <Button as="a" href={url}>
            Узнать
          </Button>
        )}
      </Description>
    </Card>
    {image && (
      <Picture>
        <img alt="" src={image} style={{ width: "100%" }} />
      </Picture>
    )}
  </TwoOne>
);
